'use client';

import type { RefObject } from 'react';

import { Form, Typography } from '@polyseme/design-system';
import { useTranslations } from 'next-intl';

import { DynamicFontTypography } from '~/landing/components';
import { ContactTab } from '~/landing/core/simulator/contact-tab';
import {
  FutureSavingsPlanner,
  useFutureSavingsForm,
} from '~/landing/core/simulator/future-savings-planner';
import { InvestmentDelayImpact } from '~/landing/core/simulator/investment-delay-impact';

import { Banner } from './components';

type ClientProps = {
  contactCardRef?: RefObject<HTMLDivElement | null>;
};

export const Client = ({ contactCardRef }: ClientProps) => {
  const t = useTranslations('landing.germen');
  const form = useFutureSavingsForm();

  return (
    <div className="w-full">
      <div className="mx-auto w-full px-4 lg:max-w-screen-2xl lg:px-8">
        <div className="space-y-2 pb-10 pt-20 text-center">
          <DynamicFontTypography className="text-title1 font-bold lg:text-title1desktop">
            {t('title')}
          </DynamicFontTypography>
          <Typography className="mx-auto max-w-6xl text-2xl text-muted-foreground">
            {t('description')}
          </Typography>
        </div>

        <Banner />

        <Form {...form}>
          <form className="space-y-10 py-10">
            <FutureSavingsPlanner blurAmounts />

            <InvestmentDelayImpact />
          </form>
        </Form>
      </div>

      <div ref={contactCardRef} className="w-full bg-gray-100 py-12">
        <div className="mx-auto w-full px-4 lg:max-w-screen-2xl lg:px-8">
          <ContactTab />
        </div>
      </div>
    </div>
  );
};
